var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"asso-team-portal w-100"},[(_vm.showFieldsLoader)?_c('div',{staticClass:"products-list-shim bordered-loader"},[_c('content-placeholders',{attrs:{"rounded":true}},[_c('content-placeholders-img'),_c('content-placeholders-heading'),_c('content-placeholders-img'),_c('content-placeholders-heading'),_c('content-placeholders-img')],1)],1):_vm._e(),(_vm.scheduleTables.length > 0 && !_vm.showFieldsLoader)?_c('div',_vm._l((_vm.scheduleTables),function(table,tableIndex){return _c('div',{key:tableIndex,staticClass:"mb-4"},[_c('div',{ref:'table-' + _vm.getDateForComparison(table.date),refInFor:true},[_c('h5',{staticClass:"field-date mb-3"},[_vm._v(_vm._s(table.formattedDate))]),_c('div',{staticClass:"pool-table-container"},[_c('table',{staticClass:"schedule-table"},[_c('thead',[_c('tr',[_c('th',{staticClass:"field-header"},[_vm._v("Time")]),_vm._l((table.fields),function(field){return _c('th',{key:field.id,staticClass:"field-header"},[_vm._v(" "+_vm._s(field.field_name)+" ")])})],2)]),_c('tbody',_vm._l((table.timeSlots),function(timeSlot,timeIndex){return _c('tr',{key:timeIndex},[_c('td',{staticClass:"field-cell"},[_c('strong',[_vm._v(_vm._s(timeSlot.time))])]),_vm._l((table.fields),function(field){return _c('td',{key:field.id,staticClass:"field-cell",class:{
                    assigned: _vm.getAssignedGame(
                      field.id,
                      timeSlot.time,
                      _vm.getDateForComparison(table.date)
                    ),
                    invalid: !_vm.isDateWithinTournamentRange(table.date),
                    available:
                      !_vm.getAssignedGame(
                        field.id,
                        timeSlot.time,
                        _vm.getDateForComparison(table.date)
                      ) && _vm.isDateWithinTournamentRange(table.date),
                    'current-division':
                      _vm.getAssignedGame(
                        field.id,
                        timeSlot.time,
                        _vm.getDateForComparison(table.date)
                      )?.division_id === _vm.selectedTournament.id,
                    'other-division':
                      _vm.getAssignedGame(
                        field.id,
                        timeSlot.time,
                        _vm.getDateForComparison(table.date)
                      )?.division_id !== _vm.selectedTournament.id,
                  },style:(_vm.getAssignedGame(
                      field.id,
                      timeSlot.time,
                      _vm.getDateForComparison(table.date)
                    )
                      ? _vm.getDivisionStyle(
                          _vm.getAssignedGame(
                            field.id,
                            timeSlot.time,
                            _vm.getDateForComparison(table.date)
                          ).division
                        )
                      : {}),on:{"dragover":function($event){$event.preventDefault();}}},[(
                      _vm.assignedGameFor(field.id, timeSlot.time, table.date)
                    )?_c('div',{staticClass:"assigned-game-container",style:({
                      cursor:
                        _vm.assignedGameFor(field.id, timeSlot.time, table.date)
                          .division_id == _vm.selectedTournament.id
                          ? 'grab'
                          : 'not-allowed',
                      userSelect:
                        _vm.assignedGameFor(field.id, timeSlot.time, table.date)
                          .division_id == _vm.selectedTournament.id
                          ? 'auto'
                          : 'none',
                    }),attrs:{"title":_vm.assignedGameFor(field.id, timeSlot.time, table.date)
                        .division_id == _vm.selectedTournament.id
                        ? 'Drag this game'
                        : '',"draggable":_vm.assignedGameFor(field.id, timeSlot.time, table.date)
                        .division_id == _vm.selectedTournament.id}},[_c('div',{staticClass:"game-info"},[_c('div',{staticClass:"teams-names teams-names2"},[(
                            _vm.assignedGameFor(
                              field.id,
                              timeSlot.time,
                              table.date
                            )
                          )?[(
                              _vm.assignedGameFor(
                                field.id,
                                timeSlot.time,
                                table.date
                              ).game_type === 2
                            )?[_vm._v(" #"+_vm._s(_vm.assignedGameFor( field.id, timeSlot.time, table.date ).game_name || "Unnamed Game")+" ")]:[_vm._v(" #"+_vm._s(_vm.assignedGameFor( field.id, timeSlot.time, table.date )?.teamA_data?.team_sr_no || "TBD")+" "),_c('span',{staticClass:"vs-text"},[_vm._v("vs")]),_vm._v(" #"+_vm._s(_vm.assignedGameFor( field.id, timeSlot.time, table.date )?.teamB_data?.team_sr_no || "TBD")+" ")]]:_vm._e()],2),_c('div',{staticClass:"division-names"},[_vm._v(" "+_vm._s(_vm.assignedGameFor(field.id, timeSlot.time, table.date) ?.division)+" ")])])]):_c('div',{staticClass:"availability-status invalid"})])})],2)}),0)])])])])}),0):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }